import { NotFound } from "pages/NotFound";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Home } from "../pages/Home";
import { Users } from "../pages/Users";
import { Templates } from "../pages/Templates";
import { Support } from "../pages/Support";
import { MetaConnect } from "../pages/MetaConnect";
import { InstabilityAlert } from "../pages/InstabilityAlert";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/contatos/*">
          <Home />
        </Route>
        <Route exact path="/users">
          <Users />
        </Route>
        <Route exact path="/templates">
          <Templates />
        </Route>
        <Route exact path="/suporte">
          <Support />
        </Route>
        <Route exact path="/meta-connect">
          <MetaConnect />
        </Route>
        <Route exact path="/instability-alert">
          <InstabilityAlert />
        </Route>
        <Route path="/login">
          <Redirect to="/" />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

export default AppRoutes;
